<template>
  <v-card class="p-4" :loading="this.loadingFile">
    <div class="flex flex-col" v-if="!this.loadingFile">
      <Lynx-Title :text="`Editar alvará - ${empresaId}`" />

      <div v-if="alvara != null">
        <div v-for="(log, index) in alvara.activities" :key="index">
          <b-tag :type="log | statusType">
            {{ log.description == "created" ? "Criou" : "Atualizou" }}</b-tag
          >
          {{ log.nome_completo }}
        </div>
        <hr class="mt-3 mb-2" style="border: 1px black solid" />
      </div>
      <div class="w-full flex justify-between items-center">
        <p class="px-2 text-xl font-display mb-4">Alvará</p>
        <Label class="mb-3" for="checkbox">
          <input
            style="font-size: 20px"
            type="checkbox"
            id="checkbox"
            v-model="alvaraDefinitivo"
            class="form-control"
            @click="alvaraProvisorio = false"
          />
          Alvara Definitivo
        </Label>
        <Label class="mb-3" for="checkbox">
          <input
            style="font-size: 20px"
            type="checkbox"
            id="checkbox"
            v-model="alvaraProvisorio"
            class="form-control"
            @click="alvaraDefinitivo = false"
          />
          Alvara Provisorio
        </Label>
      </div>
      <form class="flex flex-col">
        <label class="flex flex-col pb-5">
          <Lynx-Label label="Data de vencimento" />
          <b-datepicker
            :years-range="[-1, 5]"
            v-model="form.data_vencimento"
            :day-names="dayNames"
            :month-names="monthNames"
          />
        </label>

        <b-field class="file" required>
          <b-upload v-model="form.file">
            <a class="button is-primary">
              <b-icon icon="upload"></b-icon>
              <span>Realizar upload</span>
            </a>
          </b-upload>
          <span class="file-name" v-if="form.file">
            {{ form.file.name }}
          </span>
          <span
            class="file-name cursor-pointer"
            v-if="!form.file && arquivo"
            @click="openFile()"
          >
            {{ arquivo.nome }}
            <b-icon icon="attachment"></b-icon>
          </span>
        </b-field>
      </form>

      <Lynx-Button
        class="self-end"
        text="Salvar Alvara"
        icon="Check"
        :loading="loadingButton"
        @click.native="onSubmit"
      />
      <!--  TAXAS -->
      <div v-if="alvara">
        <hr class="mt-3 mb-2" style="border: 1px black solid" />

        <Lynx-Label class="mt-2" label="TAXA" />

        <div v-for="(taxa, index) in taxas" :key="index">
          <div class="v-line mt-2" v-if="index >= 1"></div>
          <Lynx-Button v-if="taxa.id" @click.native="removeTaxa(taxa.id)">
            Excluir
            <b-icon style="color: rgb(234, 34, 34)" icon="close"></b-icon>
          </Lynx-Button>
          <Lynx-Button @click.native="removeTaxaHundred(index)">
            Cancelar
            <b-icon style="color: #e4e132" icon="close"></b-icon>
          </Lynx-Button>
          <div class="w-full grid grid-cols-2 gap-8">
            <label class="flex flex-col pb-1 mt-2">
              <Lynx-Label label="Tipo de Taxa" />

              <b-select
                class="mt-2"
                v-model="taxa.tipo_taxa"
                placeholder="selecione uma taxa"
              >
                <option
                  v-for="status in taxasOptions"
                  :key="status.id"
                  :value="status.value"
                  v-text="status.label"
                ></option>
              </b-select>
            </label>
            <label class="flex flex-col pb-1 mt-2">
              <Lynx-Label label="Data de vencimento" />
              <b-datepicker
                :years-range="[-1, 5]"
                v-model="taxa.data_vencimento"
                :day-names="dayNames"
                :month-names="monthNames"
              />
            </label>
            <label class="flex flex-col pb-1 mt-2">
              <Lynx-Label label="Envio" />
              <b-datepicker
                v-model="taxa.envio"
                placeholder="Selecione uma data"
                :month-names="monthNames"
                :day-names="dayNames"
                :years-range="[-20, 10]"
              />
            </label>
            <label class="flex flex-col pb-1 mt-2">
              <Lynx-Label label="Valor da Taxa" />

              <InputMoney required v-model="taxa.valor"></InputMoney>
            </label>
            <label class="flex flex-col pb-1 mt-2">
              <Lynx-Label label="Status do Pagamento" />

              <b-select
                class="mt-2"
                v-model="taxa.pagamento"
                placeholder="Pagamento"
              >
                <option
                  v-for="pg in PagamentoOptions"
                  :key="pg.id"
                  :value="pg.value"
                  v-text="pg.label"
                ></option>
              </b-select>
            </label>
          </div>
          <Lynx-Textarea
            required
            placeholder="Descreva se houver observações"
            v-model="taxa.observacao"
            class="mt-2"
          />

          <b-field class="file mt-3" required>
            <b-upload v-model="taxa.file">
              <a class="button is-primary">
                <b-icon icon="upload"></b-icon>
                <span>Realizar upload</span>
              </a>
            </b-upload>
            <span class="file-name" v-if="taxa.file">
              {{ taxa.file.name }}
            </span>
            <span
              class="file-name cursor-pointer"
              v-if="arquivoTaxa"
              @click="openFile()"
            >
              {{ arquivoTaxa.nome }}
              <b-icon icon="attachment"></b-icon>
            </span>
          </b-field>
        </div>

        <div class="w-full flex justify-end">
          <Lynx-Button
            v-if="taxas[0]"
            class="self-end"
            text="Salvar Taxa"
            icon="Check"
            :loading="loadingButton"
            @click.native="onSubmitTaxa"
          />
        </div>

        <hr class="mt-3 mb-2" style="border: 1px black solid" />

        <b-table
          v-if="lista_taxas.length"
          :data="lista_taxas"
          :columns="columns"
          hoverables
          paginated
          per-page="10"
          class="w-full pb-8"
          style="font-size: 12px"
          narrowed
        >
          <template slot-scope="props">
            <b-table-column
              field="empresa_id"
              v-text="props.row.empresa_id"
              sortable
              searchable
            />
            <b-table-column field="data_vencimento" sortable>{{
              props.row.data_vencimento | formatDateToBr
            }}</b-table-column>
            <b-table-column field="tipo" sortable searchable
              ><span v-if="props.row.tipo_taxa">{{
                taxasOptions[props.row.tipo_taxa].label
              }}</span></b-table-column
            >
            <b-table-column field="envio" sortable
              ><span>{{
                props.row.envio | formatDateToBr
              }}</span></b-table-column
            >
            <b-table-column field="pagamento" sortable
              ><span v-if="props.row.pagamento">{{
                PagamentoOptions[props.row.pagamento].label
              }}</span></b-table-column
            >
                 <b-table-column field="valor" sortable
              ><span v-if="props.row.valor" >R$ {{props.row.valor | formatMoneyBr}}</span></b-table-column
            >
            <b-table-column field="acoes" sortable searchable>
              <Lynx-Button
                class="self-start mt-2"
                icon="Edit"
               icon-size="3"
                 size="small"
                @click.native="editTaxa(props.row)" />
              <Lynx-Button
                v-if="hasRole('super-admin')"
                icon="User"
                color="success-base"
                icon-size="3"
                size="small"
                @click.native="openModelLogs(props.row)"
            /></b-table-column>
          </template>
        </b-table>

        <Lynx-Button
        v-if="taxas.length == 0"
          class="self-start mt-2"
          text="adicionar"
          icon="Plus"
          @click.native="addTaxa()"
        />
      </div>
      <Logs
        v-if="modelLogs"
        :logs="logs"
        :model="modelLogs"
        @update:model="hide()"
      ></Logs>
    </div>
  </v-card>
</template>

<script>
import {
  storeAlvarasRequest,
  updateAlvarasRequest,
  showAlvarasRequest,
} from "@/services/requests/alvaras";

import {
  storeTaxasRequest,
  updateTaxasRequest,
  showTaxasRequest,
  destroyTaxasRequest,
} from "@/services/requests/taxas";
import InputMoney from "../../../components/helpers/InputMoney";

import { monthNames, dayNames } from "@/utils/utils";
import moment from "moment";
import base64Files from "../../../mixins/base64Files";
import { mapGetters } from "vuex";
import LynxTextarea from "@/components/helpers/Textarea";
import { hasRole } from "@/utils/can";
import Logs from "./Logs.vue";

export default {
  name: "Alvara",
  mixins: [base64Files],
  components: { LynxTextarea, Logs, InputMoney },

  props: {
    alvara: {
      required: null,
      type: Object,
    },
    empresaId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      modelLogs: false,
      logs: {},
      alvaraDefinitivo: null,
      alvaraProvisorio: null,
      arquivo: null,
      arquivoTaxa: null,

      loadingFile: false,
      loadingButton: false,
      monthNames,
      dayNames,
      taxas: [],

      form: {
        empresa_id: this.empresaId,
        data_vencimento: new Date(),
        definitivo: null,
      },
      errorMessage: "Não foi possivel editar o alvará",
      taxasOptions: [
        {
          label: "selecione uma taxa",
          value: 0,
        },
        {
          label: "Taxa de Alvará",
          value: 1,
        },
        {
          label: "Taxa de fiscalização",
          value: 2,
        },
        {
          label: "Taxa de Expediente",
          value: 3,
        },

        {
          label: "Taxa Mobiliaria ",
          value: 4,
        },
      ],
      PagamentoOptions: [
        {
          label: "selecione",
          value: 0,
        },
        {
          label: "Aguardando Pagamento",
          value: 1,
        },
        {
          label: "Não fez Pagamento",
          value: 2,
        },
        {
          label: "Efetuou o pagamento",
          value: 3,
        },
      ],
      columns: [
        {
          field: "empresa_id",
          label: "Empresa",
          searchable: true,
          sortable: true,
          width: 100,
        },
        {
          field: "data_vencimento",
          label: "Data vencimento",
          sortable: true,
        },
        {
          field: "tipo_taxa",
          label: "Tipo",
          sortable: true,
        },
        {
          field: "envio",
          label: "Envio",
          sortable: true,
        },
        {
          field: "pagamento",
          label: "Pagamento",
          sortable: true,
        },
            {
          field: "valor",
          label: "Valor",
          sortable: true,
        },
        {
          field: "acoes",
          label: "Açoes",
        },
      ],
      lista_taxas: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  filters: {
    statusType: (val) => {
      if (val.description === "created") {
        return "is-success";
      }
      if (val.description === "updated") {
        return "is-info";
      }

      return "default";
    },
    formatDateToBr(val) {
      return moment(val).format("DD/MM/YYYY");
    },
      formatMoneyBr: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    hasRole,

    async fetchFile() {
      this.loadingFile = true;
      if (this.alvara != null) {
        // (this.lista_taxas = [
        //   {
        //     type_document: "alvara",
        //     document_id: this.alvara.id,
        //     empresa_id: this.empresaId,
        //     tipo_taxa: 0,
        //     data_vencimento: new Date(),
        //   },
        // ]),
        await showTaxasRequest(this.alvara.id)
          .then((response) => {
            this.lista_taxas = response.data.data;

            this.lista_taxas.forEach((element) => {
              element.data_vencimento = new Date(
                moment(element.data_vencimento)
              );
              element.envio =
                element.envio == null
                  ? new Date()
                  : new Date(moment(element.envio));
            });
          })
          .finally(() => (this.loadingFile = false));

        await showAlvarasRequest(this.alvara.id)
          .then((response) => {
            // console.log(response.data.data.arquivo)

            this.arquivo = response.data.data.arquivo;
          })
          .finally(() => (this.loadingFile = false));
      }
      this.loadingFile = false;
    },
    async onSubmit() {
      this.loadingButton = true;

      let form;
      if (this.form.file) {
        form = {
          ...this.form,
          file: await this.convertFileToBase64(this.form.file),
          data_vencimento: moment(this.form.data_vencimento).format(
            "YYYY-MM-DD"
          ),
          definitivo: this.alvaraDefinitivo == true ? 1 : 0,
        };
        // Faça algo com o objeto 'form' aqui
      } else {
        form = {
          ...this.form,
          data_vencimento: moment(this.form.data_vencimento).format(
            "YYYY-MM-DD"
          ),
          definitivo: this.alvaraDefinitivo == true ? 1 : 0,
        };
        // Lógica para lidar com a ausência do arquivo
      }

      if (this.alvara == null) {
        storeAlvarasRequest(form)
          .then(() => {
            // this.$emit("edit-alvara");
            this.$snack.success("Alvará  criado com sucesso");
          })
          .catch((err) =>
            this.$snack.error(err.response.data.message || this.errorMessage)
          )
          .finally(() => (this.loadingButton = false));
      } else {
        updateAlvarasRequest(this.alvara.id, form)
          .then(() => {
            // this.$emit("edit-alvara");
            this.$snack.success("Alvará  atualizado com sucesso");
          })
          .catch((err) =>
            this.$snack.error(err.response.data.message || this.errorMessage)
          )
          .finally(() => (this.loadingButton = false));
      }
    },
    async onSubmitTaxa() {
      // Create a copy of the 'this.taxas' array
      this.loadingFile = true;
let taxasCopy = this.taxas.map(taxa => {
  let copy = {
    type_document: taxa.type_document,
    document_id: taxa.document_id,
    empresa_id: taxa.empresa_id,
    tipo_taxa: taxa.tipo_taxa,
    data_vencimento: taxa.data_vencimento,
    envio: taxa.envio,
    pagamento: taxa.pagamento,
    observacao: taxa.observacao,
    file: taxa.file,
    valor: taxa.valor
  };

  // Only include the 'id' property if it exists in the original object
  if ('id' in taxa) {
    copy.id = taxa.id;
  }

  return copy;
});



      for (let index = 0; index < taxasCopy.length; index++) {
        if (taxasCopy[index].file) {
          taxasCopy[index].file = await this.convertFileToBase64(
            taxasCopy[index].file
          );
        }
        
        taxasCopy[index].data_vencimento = moment(
          taxasCopy[index].data_vencimento
        ).format("YYYY-MM-DD");

        taxasCopy[index].envio = moment(taxasCopy[index].envio).format(
          "YYYY-MM-DD"
        );
      }



     if (taxasCopy[0].file  || this.arquivoTaxa ) {

      if (taxasCopy[0]) {
        await storeTaxasRequest(taxasCopy)
          .then((response) => {
            if (!taxasCopy[0].id) {
              this.$snack.success("Taxa Criada");
            } else {
              this.$snack.success("Taxa Atualizada");
            }
          })
          .catch((err) =>
            this.$snack.error(err.response.data.message || this.errorMessage)
          )
          .finally(() => {
            this.loadingButton = false;
      this.removeTaxaHundred(0);

          });
      }

      }else{
            this.loadingButton = false;

              this.$snack.warning("Arquivo Obrigatorio");

      }


      this.fetchFile();
    },
    openFile() {
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${this.arquivo.id}/open?token=${this.getToken}`
      );
    },
    addTaxa() {
      this.taxas.push({
        type_document: "alvara",
        document_id: this.alvara.id,
        empresa_id: this.empresaId,
        tipo_taxa: 0,
        data_vencimento: new Date(),
        file: null,
        envio: new Date(),
        pagamento: 0,
        observacao: null,
        valor: 0,
      });
    },
    editTaxa(taxa) {
      this.arquivoTaxa = taxa.file;
      this.taxas = [
        {
          type_document: "alvara",
          document_id: this.alvara.id,
          empresa_id: taxa.empresa_id,
          tipo_taxa: taxa.tipo_taxa,
          data_vencimento: taxa.data_vencimento,
          envio: taxa.envio == null ? new Date() : taxa.envio,
          pagamento: taxa.pagamento,
          observacao: taxa.observacao,
          id: taxa.id,
          valor: taxa.valor == null ? 0 : taxa.valor,
        },
      ];
    },
    removeTaxaHundred(posicao) {
      this.arquivoTaxa = null;

      if (posicao >= 0 && posicao < this.taxas.length) {
        this.taxas.splice(posicao, 1); // Remove o item na posição especificada
      }
    },
    removeTaxa(id) {
      this.$buefy.dialog.confirm({
        message: "Deseja realmente excluir a Taxa?",
        confirmText: "Excluir",
        cancelText: "Cancelar",
        type: "is-danger",
        onConfirm: () => this.onDeleteTaxa(id),
      });
    },
    onDeleteTaxa(id) {
      destroyTaxasRequest(id)
        .then(() => {
          this.$snack.success("Taxa excluida com sucesso");
          this.removeTaxaHundred(0);
          this.fetchFile();
        })
        .catch(() => this.$snack.error("Não foi possivel excluir a taxa"));
    },
    openModelLogs(value) {
      this.modelLogs = true;
      this.logs = value.logs;
    },

    hide() {
      this.modelLogs = false;
    },
  },
  beforeMount() {
    if (this.alvara != null) {
      if (this.alvara.data_vencimento != null) {
        this.form = {
          empresa_id: this.empresaId,
          data_vencimento: new Date(moment(this.alvara.data_vencimento)),
          definitivo: this.alvara.definitivo == 1,
        };

        this.alvaraDefinitivo = this.alvara.definitivo == 1;
        this.alvaraProvisorio = this.alvara.definitivo == null;

        // }else{
        //     this.form = {
        //     empresa_id: this.empresaId,
        //     data_vencimento: new Date(),
        //   };
      }
    } else {
      this.form = {
        empresa_id: this.empresaId,
        data_vencimento: new Date(),
      };
    }

    // if (this.form.data_vencimento < new Date())
    //   this.form.data_vencimento = null;
  },
  mounted() {
    this.fetchFile();
  },
};
</script>

<style scoped>
.v-line {
  height: 0.1vw;
  width: 100%;
  border-width: 0;
  color: rgb(63, 62, 62);
  background-color: rgb(35, 34, 34);
}
</style>
